import { useEffect, FC } from 'react';
import Noodle from '@components/Icons/Noodle';
import Link from 'next/link';
import { LinkedinLogo } from '@phosphor-icons/react';
import { getUrl, IDENTIFIERS } from '@/helpers/urlsHelper';
import Button from '@/components/DesignLibrary/Button';
import s from './LandingLayout.module.scss';

const LandingLayout: FC = ({ children }) => {
  useEffect(() => {
    const originalBackgroundColor = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#f7fafd';

    return () => {
      document.body.style.backgroundColor = originalBackgroundColor;
    };
  }, []);

  return (
    <>
      <nav className={s.nav}>
        <div className={s.content}>
          <Link className={s.logo} href="https://www.glade.ai">
            <Noodle width={24} height={24} />
          </Link>
          <Button href="https://www.glade.ai/platform" size="sm" variant="secondary" className={s.platform}>
            Platform
          </Button>
          <div>
            <Button href={getUrl(IDENTIFIERS.CREATOR_SIGN_IN)} size="sm" variant="secondary" className={s.login}>
              Log In
            </Button>
            <Button href="https://www.glade.ai/book-a-demo" size="sm" variant="primary" className={s.more}>
              Learn More
            </Button>
          </div>
        </div>
      </nav>
      {children}
      <footer className={s.footer}>
        <div className={s.content}>
          <Noodle width={24} height={24} fill="var(--color-noodle)" />
          <p className="body-md-bold">© 2025 Glade AI</p>
          <div className={s.links}>
            <Link href="https://www.glade.ai/privacy-policy">Privacy Policy</Link>
            <Link href="https://www.glade.ai/terms-and-conditions">Terms and Conditions</Link>
            <Link href="https://blog.glade.ai">
              Blog
            </Link>
            <Link href="https://noodle.shop/contact">Contact</Link>
            <Link href="https://noodle.shop/client-success/glade-subscription">Pricing</Link>
            <Link href="https://www.linkedin.com/company/noodleshops" aria-label="Linkedin">
              <LinkedinLogo width={20} height={20} fill="rgb(50, 117, 176)" weight="fill" />
            </Link>
          </div>
        </div>
      </footer>
    </>
  );
};

export default LandingLayout;
